import React, { useEffect, useMemo, useRef, useState } from 'react';
import cls from '@utils/css-select';
import styles from './styles.scss';
import QuestionBox from './component/question-box/questions-box';
import FilterBox from './component/filter-box/filter-box';
import { history } from '@store/history';
import useSelectData, { SelectType } from './useSelectData';
import { sendEvent } from '@utils/core/track';
import PageContainer from 'containers/en/page-container';

const cx = cls(styles);

const FILTER_FIRST_KEY = 'job';
const LAST_FIRST_KEY = 'workType';

export default function EnLandingHome() {
	const selectData = useSelectData();
	const [curJobFilterVal, setJobVal] = useState('');
	const [curTypeFilterVal, setTypeVal] = useState('');
	const [recruitListData, setListData] = useState<SelectType[]>([]);

	useEffect(() => {
		setListData(
			selectData.filter((v: SelectType) => {
				const isSatifyJob = !curJobFilterVal || v[FILTER_FIRST_KEY] === curJobFilterVal;
				const isSatifyType = !curTypeFilterVal || v[LAST_FIRST_KEY] === curTypeFilterVal;
				return isSatifyJob && isSatifyType;
			})
		);
	}, [selectData, curJobFilterVal, curTypeFilterVal]);

	const listenSelect = (value: string, type: string) => {
		type === FILTER_FIRST_KEY ? setJobVal(value) : setTypeVal(value);
	};

	const toDetail = (id: number) => {
		sendEvent({
			eventId: 'joblist_clickjob',
		});
		history.push(`/en/recruit/detail/${id}`);
	};

	return (
		<div className={`en ${cx('en-recruit')}`}>
			<PageContainer>
				<div className={cx('recruit-banner')}>Build the no. 1 global school with us!</div>
				<div className={`en ${cx('en-recruit-container')}`}>
					<div className={cx('en-recruit-title')}>
						<p>Want to travel and work? </p>
						<p>We’ve got jobs wordwide</p>
					</div>
					<FilterBox selectData={selectData} customSelEvent={listenSelect} />
					<div className={cx('en-recruit-items')}>
						{recruitListData.map((item: SelectType, index) => (
							<div key={index} className={cx('item-cur')}>
								<div className={cx('item-content')}>
									<div className={cx('item-title')} onClick={() => toDetail(item.id)}>
										{item.job}
									</div>
									<div className={cx('item-desc')}>
										{item.workType} | {item.department} | {item.country}{' '}
									</div>
								</div>
								<div className={cx('controls')} onClick={() => toDetail(item.id)}>
									Apply Now ➞
								</div>
							</div>
						))}
					</div>
				</div>
				<QuestionBox />
			</PageContainer>
		</div>
	);
}
